import React from "react";
import { useForm, useWatch } from "react-hook-form";

import { stepperFormValidationMapper } from "@utilities";
import { STEP_8_VALIDATIONS } from "../../Validations/step8";
import useFormStepControl from "@hooks/useFormStepControl";
import { ActionButtons } from "../../Components";
import { OtherInformation } from "./groups/OtherInformation";
import { Confirmation } from "./elements/Confirmation";
import { remapNewValues } from "../../../ApplicationKYC/Utilities";

export const FormStep8 = React.memo(() => {
  const {
    formDraft,
    submitForm,
    isSent,
    handleActionButtonClick,
    submitType,
    validateForm
  } = useFormStepControl();

  const { handleSubmit, control } = useForm({
    resolver: (values, context) =>
      validateForm(values, context, () => stepperFormValidationMapper(values, STEP_8_VALIDATIONS)),
    mode: "onSubmit",
    shouldFocusError: true,
    context: {
      submitType
    },
    defaultValues: formDraft.personData
  });
  const approve = useWatch({ control, name: "Approve" });

  const onSubmit = data => {
    if (submitType === "next") {
      // this is from old stepper
      const newValues = remapNewValues(JSON.parse(JSON.stringify(data)));
      //Remap all data
      const finalData = JSON.parse(
        JSON.stringify(newValues, (_key, value) => {
          if (value === 0 || value === false) return "0";
          if (value === 1 || value === true) return "1";
          if (typeof value === "number") return value.toString();
          if (value === null) return "";
          return value;
        })
      );
      return submitForm({ data: { personData: finalData } }, submitType, true);
    }
    submitForm(data, submitType);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <OtherInformation control={control} />
        <Confirmation control={control} />
        <ActionButtons
          isLoading={isSent}
          submitDisabled={!approve}
          handlePrevStep={handleActionButtonClick}
          handleNextStep={handleActionButtonClick}
        />
      </form>
    </>
  );
});
